import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Icon } from 'semantic-ui-react';
import * as shared from '../assets/shared.module.scss';
import * as classes from './classes.module.scss';
import Sizes from './sizes';

export const renderTitle = (title, authorName, isHidden) => {
  const hidden = isHidden ? (
    <Icon name="eye slash" />
  ) : null;
  return (
    <div className={ classnames(shared.title, classes.title) }>
      <strong>
        { hidden }
        { title }
      </strong>
      <span>
        by&nbsp;
        { authorName }
      </span>
    </div>
  );
};

const WorkDetails = ({
  landscape,
  displayPaperWidth,
  displayPaperHeight,
  displayPrintWidth,
  displayPrintHeight,
  displayPrintWidthNoMat,
  displayPrintHeightNoMat,
  frameMat,
  title,
  authorName,
  price,
  nonGlarePrice,
  paperMaterial,
  frame,
  frameDisplayDepth,
  frameDisplayWidth,
  frameFinalFramedSize,
  columns,
  showPrice,
  isHidden,
  isWorkSizeHidden,
  currency,
  nonGlare
}) => {
  if (!title) {
    return null;
  }

  const sizesProps = {
    landscape,
    displayPaperWidth,
    displayPaperHeight,
    displayPrintWidth,
    displayPrintHeight,
    displayPrintWidthNoMat,
    displayPrintHeightNoMat,
    frameMat,
    frame,
    frameDisplayDepth,
    frameDisplayWidth,
    isWorkSizeHidden,
    paperMaterial,
    frameFinalFramedSize,
    nonGlare
  };

  if (columns) {
    const renderPrice = showPrice ? (
      <div className={ classnames(classes.details, classes.price) }>
        Price:&nbsp;
        { currency }
        { parseFloat(nonGlare ? nonGlarePrice : price).toFixed(2) }
      </div>
    ) : null;

    return (
      <div className={ classes.columns }>
        { renderTitle(title, authorName, isHidden) }
        <div className={ classes.details }>
          <Sizes { ...sizesProps } />
        </div>
        { renderPrice }
      </div>
    );
  }

  return (
    <>
      { renderTitle(title, authorName, isHidden) }
      <div className={ classes.details }>
        Price:&nbsp;
        { currency }
        { parseFloat(nonGlare ? nonGlarePrice : price).toFixed(2) }
        <Sizes { ...sizesProps } />
      </div>
    </>
  );
};

WorkDetails.propTypes = {
  landscape: PropTypes.bool,
  frameDisplayWidth: PropTypes.number,
  displayPaperWidth: PropTypes.number,
  displayPaperHeight: PropTypes.number,
  displayPrintWidth: PropTypes.number,
  displayPrintHeight: PropTypes.number,
  displayPrintWidthNoMat: PropTypes.number,
  displayPrintHeightNoMat: PropTypes.number,
  frameMat: PropTypes.number,
  title: PropTypes.string,
  authorName: PropTypes.string,
  price: PropTypes.number,
  nonGlarePrice: PropTypes.number,
  paperMaterial: PropTypes.string,
  frameFinalFramedSize: PropTypes.string,
  frame: PropTypes.string,
  frameDisplayDepth: PropTypes.string,
  columns: PropTypes.bool,
  showPrice: PropTypes.bool,
  isHidden: PropTypes.bool,
  isWorkSizeHidden: PropTypes.bool,
  currency: PropTypes.string,
  nonGlare: PropTypes.bool
};

export default WorkDetails;
